import React, { createContext, useState } from 'react';

export const FilterContext = createContext();

export const FilterProvider = ({ children }) => {
  const [filters, setFilters] = useState({});
  const [selectedFilters, setSelectedFilters] = useState({});
  const [DisplayFiltersName, setDisplayFiltersName] = useState({}); 

  const updateFilters = (variableName, selectedValues) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [variableName]: selectedValues,
    }));
  };

  const resetFilters = () => {
    setSelectedFilters({});
    setDisplayFiltersName({});
  };

  return (
    <FilterContext.Provider
      value={{
        filters,
        setFilters,
        selectedFilters,
        setSelectedFilters,
        updateFilters,
        resetFilters,
        DisplayFiltersName, // Provide DisplayFiltersName
        setDisplayFiltersName, // Provide the function to update DisplayFiltersName
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};
